import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { npsStart } from '../api';

function useStart() {
  const [state, setState] = useState<{
    loading: boolean;
    error: boolean;
  }>({ loading: false, error: false });

  const { enqueueSnackbar } = useSnackbar();

  async function handleStart(config: AxiosRequestConfig) {
    try {
      setState({ loading: true, error: false });

      const response = await npsStart(config);

      enqueueSnackbar(response, { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    } catch (error) {
      const message = (error as AxiosError).response?.data?.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    } finally {
      setState({ loading: false, error: false });
    }
  }

  return { handleStart, startState: state };
}

export default useStart;
